import * as ActionTypes from "../action-types";

// Constants & Config

// Services

const STYLES_INITIAL_STATE = {
  loading: {
    general: false,
    application: false,
    employee: false,
    employer: false,
    remark: false,
    group: false,
    payroll: false,
    dashboardAll: false,
    dashboardDaily: false,
    dashboardMonthly: false,
  },
};

export const style = (state = STYLES_INITIAL_STATE, action) => {
  let newState = JSON.parse(JSON.stringify(state));

  if (!action) return newState;

  switch (action.type) {
    case ActionTypes.SET_LOADING_GENERAL: {
      newState.loading.general = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_GENERAL: {
      newState.loading.general = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_APPLICATION: {
      newState.loading.application = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_APPLICATION: {
      newState.loading.application = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_EMPLOYEE: {
      newState.loading.employee = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_EMPLOYEE: {
      newState.loading.employee = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_EMPLOYER: {
      newState.loading.employer = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_EMPLOYER: {
      newState.loading.employer = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_REMARK: {
      newState.loading.remark = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_REMARK: {
      newState.loading.remark = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_GROUP: {
      newState.loading.employee = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_GROUP: {
      newState.loading.employee = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_PAYROLL: {
      newState.loading.payroll = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_PAYROLL: {
      newState.loading.payroll = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_COMPANY: {
      newState.loading.company = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_COMPANY: {
      newState.loading.company = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_BILLING: {
      newState.loading.billing = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_BILLING: {
      newState.loading.billing = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_DASHBOARD_ALL: {
      newState.loading.dashboardAll = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_DASHBOARD_ALL: {
      newState.loading.dashboardAll = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_DASHBOARD_DAILY: {
      newState.loading.dashboardDaily = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_DASHBOARD_DAILY: {
      newState.loading.dashboardDaily = false;
      return newState;
    }

    case ActionTypes.SET_LOADING_DASHBOARD_MONTHLY: {
      newState.loading.dashboardMonthly = true;
      return newState;
    }

    case ActionTypes.UNSET_LOADING_DASHBOARD_MONTHLY: {
      newState.loading.dashboardMonthly = false;
      return newState;
    }
    default: {
      return state;
    }
  }
};
